
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import LanguageIcon from '@mui/icons-material/Language';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import GroupIcon from '@mui/icons-material/Group';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import PaymentsIcon from '@mui/icons-material/Payments';
import TtkList from './TtkList';
const PhotographyTTK = ({ data }) => {
    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><LocalOfferIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Services Offered :</b>&nbsp;<TtkList data={data?.serviceOffer} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area of working :</b>&nbsp;<TtkList data={data?.areaOfWork} /></p>
                        </div>
                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><GroupIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Team Size :</b>&nbsp;<span>{data?.noOfEmployee}</span></p>
                        </div>
                        {/* <div className='col-md-4'>
                            <p><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Studio Photography Price :</b>&nbsp;<span>&#8377; {data.albumPrice}</span></p>
                        </div> */}

                        <div className='col-md-4'>
                            <p><LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Travel Preference :</b>&nbsp;<TtkList data={data?.travelPrefer} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Studio Photography price :</b>&nbsp;<span>&#8377; {data?.studioPhotoPrice}</span></p>
                        </div>
                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Budget (Photo Package) Price :</b>&nbsp;<span>&#8377;{data?.budgetPhotoPrice}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Budget (Photo & Video) Price:</b>&nbsp;<span>&#8377; {data?.budgetVideoPrice}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><AccessTimeFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Delivery Time :</b>&nbsp;<TtkList data={data?.deliveryDate} /></p>
                        </div>
                        
                    </div>
                    <div className='row mb-1'>
                        {
                            data?.videographyPrice && (
                                <div className='col-md-4'>
                                    <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Traditional Videography Price :</b>&nbsp;<span>&#8377;{data?.videographyPrice}</span></p>
                                </div>
                            )
                        }

                        {/* <div className='col-md-4'>
                            <p><LanguageIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Most Booked Package :</b>&nbsp;<span>&#8377;{data.mostBookedPackage}</span></p>
                        </div> */}
                        {
                            data?.canditPrice && (
                                <div className='col-md-4'>
                                    <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Candid Photography Price :</b>&nbsp;<span>&#8377; {data?.canditPrice}</span></p>
                                </div>)

                        }
                        {
                            data?.cinematicPrice && (
                                <div className='col-md-4'>
                                    <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Cinematic Photography Price :</b>&nbsp;<span>&#8377; {data?.cinematicPrice}</span></p>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default PhotographyTTK